var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.imgList),function(item,index){return _c('img',{key:index,staticClass:"task-img",attrs:{"src":item,"alt":""}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }